import {
  type GradeElementaryMiddleAbbr,
  SCHOOL_TYPE_KO_ABBR,
  SCHOOL_TYPE_KO_FULL,
  SUBJECT_HIGH_SHORT,
} from './constants'
import type { AllGradeSubject, GradeHigh, SchoolType, Semester } from './schemas'

export const getKoreanSchoolType = (schoolType: SchoolType) => SCHOOL_TYPE_KO_ABBR[schoolType]

// 초1, 중1 처럼 붙여 쓰고, 고등은 과목명을 그대로 돌려준다.
export const getKoreanElementaryMiddleGradeAbbr = (
  grade: AllGradeSubject,
  schoolType: SchoolType,
): GradeElementaryMiddleAbbr | GradeHigh => {
  if (!isNaN(Number(grade))) {
    return `${SCHOOL_TYPE_KO_ABBR[schoolType]}${grade}` as GradeElementaryMiddleAbbr
  }
  return grade as GradeHigh
}

export const getKoreanHighSubjectShort = (subject: GradeHigh) => SUBJECT_HIGH_SHORT[subject]

// 핑계고등학교 -> 핑계고 / 오리무중학교 -> 오리무중
export const shortenSchoolName = (schoolName: string) =>
  schoolName
    .replace(SCHOOL_TYPE_KO_FULL.ELEMENTARY, SCHOOL_TYPE_KO_ABBR.ELEMENTARY)
    .replace(SCHOOL_TYPE_KO_FULL.MIDDLE, SCHOOL_TYPE_KO_ABBR.MIDDLE)
    .replace(SCHOOL_TYPE_KO_FULL.HIGH, SCHOOL_TYPE_KO_ABBR.HIGH)

export const getKoreanCommonGradeSemester = (option: {
  grade: AllGradeSubject
  semester: Semester
  schoolType: SchoolType
}) => {
  const koSchoolType = SCHOOL_TYPE_KO_ABBR[option.schoolType]
  const koGrade = getKoreanElementaryMiddleGradeAbbr(option.grade, option.schoolType)
  switch (option.schoolType) {
    case 'ELEMENTARY':
    case 'MIDDLE':
      return {
        koSchoolType,
        koGrade,
        grade: option.grade,
        semester: option.semester,
        koSubject: null,
      }
    case 'HIGH':
    default:
      return {
        koSchoolType,
        koGrade,
        grade: null,
        semester: null,
        koSubject: SUBJECT_HIGH_SHORT[option.grade as GradeHigh],
      }
  }
}
